export let DialogPopupCssVars = /*#__PURE__*/function (DialogPopupCssVars) {
  /**
   * Indicates how many dialogs are nested within.
   * @type {number}
   */
  DialogPopupCssVars["nestedDialogs"] = "--nested-dialogs";
  return DialogPopupCssVars;
}({});